const o = "{VersionId}", d = "{ShopId}";
export {
  d as ShopId,
  o as VersionId
};
//# sourceMappingURL=myshopApiConstants.js.map
